import React, { useEffect } from "react";
import Cookies from "js-cookie";
import config from "../configs/config";
import WelcomeAgentsModal from "../features/navigation/ui/WelcomeAgentsModal";
import AgencySearchPicker from "../features/agent-register/ui/AgencySearchPicker";
import AgencySelectedDetails from "../features/agent-register/ui/AgencySelectedDetails";
import AgentRegisterForm from "../features/agent-register/ui/AgentRegisterForm";
import AgencyCreate from "../features/agency-register/ui/AgencyCreateForm";
import { getLanguageSection } from "../shared/services/languageService";

function AgentRegister(props) {
  useEffect(() => {
    const verifylogin = setInterval(() => {
      if (Cookies.get("loggedin") === "true") {
        clearInterval(verifylogin);
        window.location.href = config.basename;
      }
    }, 1000);

    return () => clearInterval(verifylogin);
  }, []);

  const language = getLanguageSection("agentregister");

  return (
    <div id="agentregister" className="mr-ui bg-[#f3f5fb] px-4 py-10 md:px-8">
      <WelcomeAgentsModal />

      <div className="mx-auto w-full max-w-5xl">
        <div className="mx-auto mb-6 rounded-2xl border border-slate-200 bg-white p-8 shadow-marival">
          <span className="mb-4 inline-flex rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-xs font-black uppercase tracking-wide text-slate-500">{language.badge}</span>
          <h1 className="m-0 text-3xl font-black leading-tight text-[#11183f] md:text-4xl">{language.text1}</h1>
          <p className="mb-0 mt-4 max-w-3xl text-base leading-7 text-slate-600">{language.intro}</p>
          <ol className="m-0 mt-5 list-decimal space-y-2 pl-5 text-sm leading-6 text-slate-600">
            <li>{language.step1}</li>
            <li>{language.step2}</li>
            <li>{language.step3}</li>
          </ol>

          <div className="mt-6 rounded-xl border border-orange-200 bg-orange-50 p-4 text-sm leading-6 text-orange-950">
            <div className="flex flex-wrap items-center gap-3">
              <div className="m-0 flex flex-wrap items-center gap-3">
                <span>{language.alternateFlowPrefix}</span>
                <AgencyCreate
                  withButton={true}
                  buttonText={language.searchButtonText}
                  title={language.searchButtonTitle}
                />
                <span>{language.alternateFlowSuffix}</span>
              </div>
            </div>
          </div>
        </div>
        <AgencySearchPicker />
        <AgencySelectedDetails />
        <AgentRegisterForm />
      </div>
    </div>
  );
}

export default AgentRegister;
